export const barnetAreaLatLongs = [
  [51.668601, -0.18211],
  [51.668488, -0.184968],
  [51.668547, -0.18499],
  [51.668506, -0.185829],
  [51.667876, -0.187815],
  [51.666489, -0.188978],
  [51.665856, -0.189492],
  [51.665826, -0.189414],
  [51.664719, -0.190358],
  [51.663982, -0.19097],
  [51.663945, -0.191032],
  [51.663893, -0.191092],
  [51.664103, -0.191244],
  [51.664347, -0.191554],
  [51.6645, -0.19185],
  [51.664663, -0.192274],
  [51.664746, -0.192556],
  [51.664988, -0.193852],
  [51.665205, -0.195161],
  [51.665306, -0.195777],
  [51.665479, -0.19669],
  [51.665495, -0.196673],
  [51.666368, -0.196072],
  [51.667072, -0.195632],
  [51.667512, -0.195347],
  [51.667628, -0.195319],
  [51.668302, -0.194877],
  [51.66843, -0.19565],
  [51.668526, -0.196184],
  [51.668143, -0.196639],
  [51.668159, -0.196961],
  [51.668184, -0.197385],
  [51.668207, -0.198621],
  [51.668209, -0.198735],
  [51.668204, -0.19888],
  [51.668203, -0.19903],
  [51.668503, -0.199138],
  [51.668734, -0.199229],
  [51.66901, -0.199375],
  [51.669366, -0.19953],
  [51.66986, -0.1997],
  [51.670167, -0.199896],
  [51.670126, -0.200145],
  [51.670064, -0.201089],
  [51.670056, -0.201811],
  [51.67007, -0.202406],
  [51.670123, -0.203378],
  [51.669311, -0.202633],
  [51.669127, -0.202617],
  [51.668959, -0.202547],
  [51.668455, -0.202405],
  [51.667802, -0.202255],
  [51.667934, -0.202695],
  [51.668005, -0.202858],
  [51.668089, -0.203188],
  [51.668161, -0.203296],
  [51.668223, -0.203581],
  [51.668332, -0.203887],
  [51.668482, -0.204735],
  [51.668598, -0.205659],
  [51.668483, -0.205761],
  [51.667425, -0.207087],
  [51.667115, -0.207452],
  [51.666591, -0.207984],
  [51.667559, -0.209864],
  [51.666952, -0.211159],
  [51.666129, -0.210446],
  [51.665301, -0.209724],
  [51.662858, -0.207889],
  [51.662793, -0.208123],
  [51.662172, -0.210012],
  [51.661809, -0.211039],
  [51.661611, -0.211561],
  [51.661477, -0.211909],
  [51.66135, -0.21216],
  [51.661588, -0.21245],
  [51.661947, -0.212839],
  [51.662375, -0.213418],
  [51.662322, -0.213526],
  [51.661842, -0.214547],
  [51.661692, -0.214806],
  [51.660616, -0.217153],
  [51.660058, -0.21892],
  [51.660797, -0.219272],
  [51.660751, -0.21944],
  [51.660657, -0.219826],
  [51.660463, -0.220264],
  [51.659973, -0.221262],
  [51.65975, -0.221628],
  [51.659155, -0.222903],
  [51.658604, -0.223939],
  [51.658115, -0.224999],
  [51.657853, -0.22559],
  [51.657623, -0.226069],
  [51.657474, -0.225888],
  [51.657159, -0.226488],
  [51.657268, -0.226635],
  [51.657558, -0.227003],
  [51.657878, -0.22732],
  [51.658472, -0.227993],
  [51.658588, -0.228083],
  [51.658845, -0.228236],
  [51.659189, -0.228476],
  [51.659206, -0.228294],
  [51.659387, -0.228386],
  [51.65955, -0.228441],
  [51.659962, -0.228514],
  [51.659916, -0.228838],
  [51.659973, -0.228944],
  [51.659859, -0.229488],
  [51.659726, -0.229773],
  [51.659734, -0.229918],
  [51.659659, -0.230126],
  [51.659459, -0.230582],
  [51.659405, -0.230727],
  [51.659361, -0.23104],
  [51.659295, -0.231154],
  [51.659211, -0.231299],
  [51.658799, -0.232452],
  [51.658522, -0.233269],
  [51.658423, -0.233564],
  [51.658363, -0.233889],
  [51.658325, -0.234097],
  [51.65825, -0.234252],
  [51.658568, -0.234413],
  [51.658998, -0.234732],
  [51.659005, -0.234952],
  [51.659016, -0.235142],
  [51.658942, -0.235781],
  [51.65888, -0.236216],
  [51.658824, -0.23649],
  [51.658772, -0.236703],
  [51.658663, -0.237008],
  [51.658619, -0.237115],
  [51.658592, -0.237268],
  [51.658405, -0.237691],
  [51.658246, -0.2383],
  [51.657786, -0.237996],
  [51.65764, -0.238493],
  [51.657396, -0.239224],
  [51.657273, -0.239644],
  [51.657173, -0.239983],
  [51.656832, -0.241018],
  [51.657201, -0.24139],
  [51.657046, -0.241909],
  [51.656958, -0.24213],
  [51.656873, -0.242393],
  [51.656823, -0.2426],
  [51.656797, -0.242711],
  [51.656776, -0.242868],
  [51.656767, -0.243009],
  [51.656766, -0.24319],
  [51.656744, -0.243381],
  [51.656686, -0.24365],
  [51.656598, -0.243923],
  [51.656579, -0.244011],
  [51.656493, -0.244413],
  [51.65631, -0.244715],
  [51.656129, -0.245156],
  [51.655916, -0.245858],
  [51.655864, -0.246029],
  [51.655679, -0.246499],
  [51.655575, -0.246763],
  [51.655244, -0.24789],
  [51.655375, -0.24802],
  [51.655563, -0.248295],
  [51.655645, -0.248511],
  [51.655851, -0.248902],
  [51.655942, -0.249007],
  [51.656054, -0.249373],
  [51.656168, -0.249736],
  [51.656065, -0.249871],
  [51.656035, -0.249978],
  [51.656047, -0.250111],
  [51.656139, -0.250278],
  [51.656097, -0.250435],
  [51.656077, -0.250484],
  [51.656054, -0.250608],
  [51.655927, -0.250835],
  [51.655806, -0.251062],
  [51.65573, -0.251178],
  [51.655678, -0.251232],
  [51.655536, -0.251275],
  [51.655514, -0.251277],
  [51.655318, -0.251206],
  [51.655266, -0.251281],
  [51.655214, -0.251357],
  [51.655064, -0.25117],
  [51.654986, -0.251072],
  [51.654879, -0.250916],
  [51.654806, -0.250816],
  [51.654771, -0.250757],
  [51.654714, -0.250593],
  [51.654666, -0.250378],
  [51.654611, -0.249881],
  [51.652088, -0.250445],
  [51.649448, -0.251079],
  [51.648932, -0.251217],
  [51.648703, -0.251297],
  [51.648393, -0.251404],
  [51.648353, -0.251419],
  [51.647949, -0.251582],
  [51.647496, -0.251765],
  [51.64721, -0.251901],
  [51.646903, -0.252071],
  [51.646561, -0.252275],
  [51.646141, -0.252583],
  [51.645625, -0.252991],
  [51.644712, -0.253693],
  [51.644178, -0.25407],
  [51.643677, -0.254514],
  [51.643605, -0.254767],
  [51.643431, -0.25538],
  [51.643339, -0.255444],
  [51.643285, -0.255483],
  [51.643242, -0.255512],
  [51.643489, -0.256196],
  [51.643142, -0.256493],
  [51.64258, -0.25691],
  [51.641956, -0.257268],
  [51.641829, -0.257357],
  [51.641883, -0.257508],
  [51.641914, -0.257615],
  [51.641939, -0.257728],
  [51.641964, -0.257908],
  [51.641991, -0.258407],
  [51.642083, -0.258415],
  [51.642118, -0.258761],
  [51.642144, -0.258939],
  [51.64222, -0.259316],
  [51.642329, -0.259755],
  [51.642391, -0.260048],
  [51.642425, -0.260178],
  [51.642458, -0.260281],
  [51.642536, -0.260473],
  [51.64267, -0.260737],
  [51.642764, -0.26087],
  [51.642808, -0.260914],
  [51.642866, -0.260955],
  [51.643042, -0.261036],
  [51.643098, -0.26107],
  [51.64325, -0.261187],
  [51.643339, -0.261243],
  [51.643407, -0.261265],
  [51.643592, -0.261272],
  [51.643672, -0.261294],
  [51.643706, -0.261314],
  [51.643758, -0.261361],
  [51.643891, -0.261514],
  [51.643989, -0.261629],
  [51.644057, -0.261726],
  [51.644115, -0.261844],
  [51.644194, -0.262046],
  [51.644281, -0.262222],
  [51.644422, -0.262462],
  [51.644577, -0.262687],
  [51.644629, -0.262779],
  [51.644719, -0.262969],
  [51.644778, -0.263125],
  [51.644809, -0.263229],
  [51.64483, -0.263296],
  [51.643781, -0.264058],
  [51.643833, -0.264251],
  [51.643624, -0.264383],
  [51.643702, -0.264474],
  [51.643751, -0.264533],
  [51.6438, -0.264573],
  [51.643833, -0.264635],
  [51.643863, -0.264676],
  [51.643915, -0.264749],
  [51.643902, -0.264819],
  [51.644017, -0.265235],
  [51.644042, -0.265555],
  [51.644108, -0.266791],
  [51.643831, -0.26837],
  [51.643789, -0.268366],
  [51.643614, -0.268406],
  [51.643574, -0.268414],
  [51.643484, -0.268422],
  [51.643251, -0.268428],
  [51.643052, -0.268413],
  [51.64276, -0.268333],
  [51.642383, -0.26827],
  [51.642298, -0.268805],
  [51.642239, -0.269435],
  [51.642269, -0.269461],
  [51.642161, -0.269746],
  [51.642084, -0.270061],
  [51.642058, -0.270647],
  [51.642048, -0.271126],
  [51.642084, -0.271555],
  [51.642104, -0.271946],
  [51.642096, -0.27289],
  [51.641959, -0.272878],
  [51.641763, -0.27292],
  [51.641432, -0.273088],
  [51.641255, -0.273129],
  [51.641191, -0.273146],
  [51.641061, -0.273177],
  [51.640798, -0.273379],
  [51.640457, -0.273564],
  [51.640262, -0.273724],
  [51.639875, -0.273911],
  [51.639304, -0.2742],
  [51.639092, -0.274184],
  [51.638999, -0.274174],
  [51.638912, -0.274165],
  [51.638843, -0.273985],
  [51.638761, -0.273745],
  [51.638671, -0.273737],
  [51.6387, -0.274019],
  [51.638738, -0.274751],
  [51.638759, -0.275121],
  [51.638784, -0.275513],
  [51.638808, -0.275906],
  [51.638865, -0.276499],
  [51.638772, -0.276761],
  [51.638669, -0.277011],
  [51.638588, -0.277346],
  [51.638492, -0.277798],
  [51.638455, -0.277964],
  [51.638393, -0.278244],
  [51.63832, -0.278637],
  [51.6383, -0.279042],
  [51.638279, -0.279418],
  [51.63829, -0.280051],
  [51.638309, -0.28043],
  [51.638309, -0.280547],
  [51.638343, -0.281415],
  [51.638013, -0.282936],
  [51.637792, -0.283898],
  [51.6376, -0.284282],
  [51.637423, -0.28465],
  [51.637126, -0.285081],
  [51.637064, -0.285196],
  [51.636945, -0.285524],
  [51.636855, -0.286016],
  [51.636776, -0.286506],
  [51.636692, -0.286937],
  [51.636643, -0.287254],
  [51.636509, -0.287811],
  [51.636488, -0.288102],
  [51.636471, -0.288367],
  [51.636583, -0.289142],
  [51.636603, -0.289278],
  [51.636617, -0.289412],
  [51.636667, -0.289929],
  [51.636588, -0.290575],
  [51.636488, -0.291379],
  [51.636488, -0.291741],
  [51.636475, -0.291891],
  [51.636429, -0.292043],
  [51.63638, -0.29219],
  [51.635995, -0.293339],
  [51.635905, -0.293599],
  [51.635729, -0.294106],
  [51.635647, -0.294407],
  [51.635444, -0.296151],
  [51.635732, -0.297233],
  [51.635762, -0.297743],
  [51.635791, -0.298241],
  [51.635774, -0.2985],
  [51.635762, -0.298703],
  [51.635758, -0.298764],
  [51.635754, -0.298827],
  [51.635715, -0.299428],
  [51.635733, -0.299613],
  [51.635737, -0.29966],
  [51.635758, -0.299878],
  [51.635792, -0.300102],
  [51.635808, -0.300205],
  [51.635839, -0.300337],
  [51.635884, -0.300477],
  [51.635938, -0.300618],
  [51.635957, -0.300668],
  [51.636072, -0.300927],
  [51.636109, -0.301104],
  [51.636138, -0.301249],
  [51.636253, -0.301781],
  [51.636351, -0.302436],
  [51.636133, -0.302747],
  [51.63626, -0.302944],
  [51.636283, -0.302997],
  [51.636301, -0.303042],
  [51.636316, -0.303078],
  [51.636367, -0.303203],
  [51.63643, -0.303363],
  [51.636458, -0.30357],
  [51.636481, -0.303809],
  [51.636472, -0.303994],
  [51.636429, -0.30416],
  [51.63637, -0.304301],
  [51.636313, -0.30435],
  [51.63634, -0.304451],
  [51.636347, -0.304483],
  [51.6354, -0.30505],
  [51.634397, -0.305574],
  [51.634329, -0.305585],
  [51.634117, -0.305598],
  [51.633368, -0.305462],
  [51.632776, -0.305052],
  [51.63203, -0.304485],
  [51.631464, -0.303954],
  [51.630428, -0.302539],
  [51.630134, -0.302186],
  [51.629842, -0.301838],
  [51.629265, -0.301182],
  [51.628623, -0.300543],
  [51.628197, -0.300153],
  [51.627411, -0.299255],
  [51.626972, -0.298669],
  [51.626507, -0.298027],
  [51.626265, -0.297713],
  [51.6259, -0.297276],
  [51.624694, -0.295908],
  [51.624104, -0.295189],
  [51.623804, -0.29488],
  [51.623294, -0.294364],
  [51.622806, -0.293871],
  [51.622203, -0.293151],
  [51.621757, -0.292677],
  [51.620889, -0.291673],
  [51.619164, -0.2896],
  [51.618037, -0.288276],
  [51.617776, -0.288009],
  [51.617298, -0.287699],
  [51.617152, -0.287566],
  [51.616608, -0.286852],
  [51.615896, -0.286004],
  [51.615411, -0.285307],
  [51.614912, -0.28441],
  [51.614781, -0.284185],
  [51.614648, -0.283962],
  [51.614292, -0.283412],
  [51.613356, -0.2822],
  [51.6127, -0.281482],
  [51.611439, -0.28015],
  [51.610744, -0.279368],
  [51.61072, -0.27934],
  [51.610156, -0.278746],
  [51.609424, -0.277938],
  [51.608885, -0.277315],
  [51.608736, -0.277136],
  [51.608453, -0.276653],
  [51.608319, -0.276446],
  [51.608015, -0.276037],
  [51.607568, -0.275556],
  [51.607307, -0.275272],
  [51.606971, -0.274933],
  [51.606933, -0.274894],
  [51.605713, -0.273808],
  [51.605026, -0.27297],
  [51.602899, -0.270247],
  [51.602768, -0.27008],
  [51.601719, -0.268736],
  [51.601475, -0.268448],
  [51.600733, -0.267616],
  [51.60037, -0.267156],
  [51.600289, -0.267052],
  [51.599424, -0.266154],
  [51.599008, -0.265731],
  [51.598554, -0.265188],
  [51.598182, -0.264762],
  [51.59778, -0.264276],
  [51.597468, -0.263878],
  [51.597122, -0.263377],
  [51.596597, -0.262682],
  [51.596371, -0.262399],
  [51.595969, -0.261902],
  [51.594911, -0.260642],
  [51.594174, -0.25977],
  [51.59277, -0.258246],
  [51.592577, -0.25804],
  [51.592252, -0.257691],
  [51.592023, -0.257421],
  [51.59176, -0.257029],
  [51.590701, -0.25563],
  [51.590063, -0.254761],
  [51.589788, -0.25427],
  [51.589578, -0.253949],
  [51.589565, -0.253932],
  [51.589206, -0.253387],
  [51.589043, -0.25313],
  [51.588545, -0.252537],
  [51.587938, -0.251938],
  [51.586383, -0.25035],
  [51.586047, -0.249982],
  [51.584574, -0.248535],
  [51.584364, -0.248284],
  [51.5843, -0.248368],
  [51.584252, -0.248504],
  [51.583896, -0.249932],
  [51.5838, -0.250382],
  [51.583698, -0.250823],
  [51.583576, -0.251409],
  [51.583457, -0.251668],
  [51.58305, -0.252044],
  [51.582794, -0.252304],
  [51.582697, -0.252417],
  [51.58262, -0.252536],
  [51.582429, -0.252885],
  [51.582297, -0.253143],
  [51.582274, -0.253212],
  [51.582229, -0.253417],
  [51.582189, -0.25354],
  [51.582122, -0.253692],
  [51.582044, -0.253829],
  [51.58192, -0.253999],
  [51.581808, -0.254123],
  [51.581584, -0.254335],
  [51.581511, -0.25438],
  [51.581464, -0.254396],
  [51.581395, -0.254394],
  [51.581207, -0.254349],
  [51.581112, -0.254334],
  [51.580923, -0.254318],
  [51.580827, -0.254312],
  [51.580599, -0.254316],
  [51.580405, -0.254335],
  [51.580235, -0.254372],
  [51.580052, -0.25443],
  [51.579943, -0.254484],
  [51.579804, -0.254586],
  [51.579743, -0.254613],
  [51.579672, -0.25463],
  [51.579599, -0.254632],
  [51.579487, -0.254613],
  [51.578988, -0.254465],
  [51.578843, -0.254415],
  [51.578461, -0.254245],
  [51.57807, -0.254103],
  [51.578022, -0.254079],
  [51.577811, -0.253944],
  [51.577397, -0.25365],
  [51.577316, -0.253598],
  [51.577271, -0.253569],
  [51.577014, -0.253428],
  [51.576843, -0.253353],
  [51.576533, -0.253234],
  [51.575728, -0.252934],
  [51.575511, -0.252819],
  [51.575448, -0.252791],
  [51.575136, -0.252716],
  [51.574923, -0.252623],
  [51.574467, -0.252353],
  [51.574124, -0.252129],
  [51.573895, -0.251966],
  [51.573717, -0.251825],
  [51.573275, -0.251442],
  [51.57318, -0.251372],
  [51.573136, -0.251355],
  [51.573078, -0.251366],
  [51.573044, -0.251389],
  [51.573007, -0.25143],
  [51.572967, -0.251492],
  [51.572868, -0.251698],
  [51.572816, -0.25186],
  [51.572763, -0.252119],
  [51.57273, -0.252315],
  [51.572704, -0.252519],
  [51.57269, -0.252641],
  [51.572689, -0.252891],
  [51.572676, -0.252971],
  [51.572656, -0.253019],
  [51.572632, -0.253052],
  [51.572577, -0.253101],
  [51.572505, -0.25313],
  [51.572438, -0.253131],
  [51.572373, -0.253106],
  [51.572343, -0.253084],
  [51.572293, -0.253036],
  [51.57197, -0.252863],
  [51.571689, -0.252663],
  [51.571506, -0.25251],
  [51.571283, -0.252083],
  [51.571182, -0.251911],
  [51.571108, -0.251772],
  [51.571085, -0.251753],
  [51.57091, -0.251611],
  [51.570759, -0.251513],
  [51.570604, -0.251378],
  [51.57047, -0.251322],
  [51.570398, -0.251282],
  [51.570321, -0.251205],
  [51.570265, -0.25115],
  [51.570112, -0.250769],
  [51.569847, -0.2505],
  [51.569571, -0.250219],
  [51.569391, -0.250034],
  [51.569368, -0.250009],
  [51.569159, -0.249785],
  [51.569091, -0.249672],
  [51.569029, -0.249582],
  [51.56897, -0.249495],
  [51.568905, -0.249428],
  [51.56887, -0.24933],
  [51.568859, -0.24918],
  [51.568791, -0.249059],
  [51.568763, -0.248999],
  [51.568692, -0.248851],
  [51.568622, -0.248771],
  [51.568544, -0.248706],
  [51.568534, -0.248597],
  [51.568529, -0.248553],
  [51.568659, -0.248226],
  [51.568617, -0.24808],
  [51.568516, -0.247862],
  [51.568476, -0.247615],
  [51.568461, -0.24731],
  [51.568511, -0.247135],
  [51.568579, -0.247041],
  [51.568624, -0.247024],
  [51.568681, -0.247084],
  [51.568733, -0.247148],
  [51.568815, -0.247282],
  [51.568872, -0.247345],
  [51.568928, -0.247391],
  [51.568953, -0.247393],
  [51.568971, -0.247383],
  [51.568979, -0.247368],
  [51.569044, -0.247192],
  [51.569014, -0.247029],
  [51.568982, -0.246861],
  [51.568983, -0.246632],
  [51.568997, -0.24661],
  [51.569032, -0.246555],
  [51.569066, -0.246525],
  [51.569182, -0.246561],
  [51.569255, -0.246631],
  [51.569292, -0.246631],
  [51.569322, -0.246616],
  [51.569343, -0.246588],
  [51.569429, -0.24648],
  [51.569605, -0.246165],
  [51.569711, -0.246103],
  [51.569783, -0.24607],
  [51.569838, -0.246058],
  [51.569898, -0.246053],
  [51.569926, -0.246059],
  [51.56994, -0.246071],
  [51.569948, -0.246088],
  [51.569952, -0.246118],
  [51.569963, -0.246183],
  [51.569953, -0.24626],
  [51.569926, -0.246362],
  [51.569813, -0.246496],
  [51.569863, -0.246559],
  [51.570021, -0.246575],
  [51.570177, -0.246514],
  [51.570418, -0.246503],
  [51.570514, -0.246465],
  [51.570614, -0.246386],
  [51.570898, -0.246026],
  [51.570928, -0.246007],
  [51.570957, -0.246009],
  [51.570985, -0.246024],
  [51.571091, -0.246142],
  [51.571164, -0.246274],
  [51.571249, -0.246472],
  [51.571298, -0.246544],
  [51.571476, -0.246721],
  [51.571492, -0.246729],
  [51.571517, -0.246735],
  [51.571542, -0.246731],
  [51.571568, -0.246717],
  [51.571616, -0.246673],
  [51.571645, -0.246625],
  [51.571765, -0.246395],
  [51.572117, -0.246112],
  [51.572154, -0.246087],
  [51.572174, -0.246066],
  [51.572186, -0.246042],
  [51.572198, -0.245993],
  [51.572198, -0.245932],
  [51.572189, -0.245869],
  [51.572172, -0.245819],
  [51.572154, -0.245791],
  [51.572137, -0.245775],
  [51.572032, -0.245656],
  [51.571917, -0.245454],
  [51.571914, -0.245242],
  [51.571951, -0.245102],
  [51.572043, -0.244901],
  [51.572171, -0.244765],
  [51.572233, -0.244647],
  [51.572288, -0.24452],
  [51.572307, -0.244489],
  [51.572352, -0.244459],
  [51.572437, -0.244445],
  [51.572517, -0.244389],
  [51.572553, -0.244339],
  [51.572564, -0.244289],
  [51.57257, -0.244224],
  [51.572566, -0.244179],
  [51.572559, -0.244152],
  [51.572543, -0.244125],
  [51.572424, -0.244104],
  [51.572356, -0.244115],
  [51.572354, -0.244112],
  [51.572321, -0.244039],
  [51.572304, -0.243921],
  [51.572325, -0.243646],
  [51.572393, -0.243376],
  [51.572445, -0.24321],
  [51.572501, -0.243004],
  [51.57251, -0.242969],
  [51.572516, -0.242919],
  [51.572516, -0.242868],
  [51.572509, -0.242792],
  [51.572483, -0.242617],
  [51.572487, -0.242497],
  [51.572531, -0.242419],
  [51.572569, -0.242419],
  [51.572603, -0.242435],
  [51.572629, -0.242455],
  [51.572644, -0.242482],
  [51.572677, -0.242583],
  [51.57269, -0.242602],
  [51.572709, -0.242607],
  [51.572728, -0.242604],
  [51.572742, -0.242592],
  [51.572765, -0.24256],
  [51.572796, -0.242492],
  [51.572801, -0.242374],
  [51.572783, -0.242217],
  [51.572791, -0.242142],
  [51.572805, -0.242016],
  [51.572749, -0.241742],
  [51.57273, -0.241498],
  [51.57268, -0.241411],
  [51.572671, -0.241394],
  [51.572657, -0.241375],
  [51.572632, -0.241361],
  [51.572595, -0.241354],
  [51.572473, -0.241376],
  [51.572404, -0.24137],
  [51.572296, -0.241344],
  [51.572218, -0.241271],
  [51.572164, -0.241206],
  [51.572117, -0.241108],
  [51.572135, -0.240956],
  [51.572297, -0.240869],
  [51.572344, -0.240785],
  [51.57235, -0.240719],
  [51.572333, -0.240687],
  [51.572297, -0.240625],
  [51.572194, -0.240648],
  [51.572188, -0.240585],
  [51.572186, -0.240562],
  [51.572216, -0.240522],
  [51.572289, -0.240463],
  [51.572356, -0.240332],
  [51.572385, -0.240138],
  [51.572392, -0.240081],
  [51.572393, -0.240017],
  [51.572388, -0.23997],
  [51.572381, -0.23994],
  [51.572368, -0.239917],
  [51.57235, -0.239903],
  [51.572329, -0.239905],
  [51.572283, -0.239972],
  [51.572184, -0.240061],
  [51.572122, -0.240075],
  [51.572086, -0.239996],
  [51.572071, -0.239904],
  [51.572088, -0.239807],
  [51.572093, -0.239749],
  [51.572101, -0.239652],
  [51.572068, -0.239438],
  [51.572088, -0.239209],
  [51.572215, -0.239057],
  [51.572252, -0.238867],
  [51.572143, -0.238702],
  [51.571982, -0.238492],
  [51.571946, -0.238444],
  [51.571907, -0.238382],
  [51.571791, -0.23817],
  [51.571778, -0.238133],
  [51.57177, -0.238087],
  [51.571769, -0.238015],
  [51.571775, -0.237944],
  [51.571785, -0.237903],
  [51.571812, -0.237852],
  [51.571832, -0.237837],
  [51.571854, -0.237831],
  [51.571875, -0.237841],
  [51.571905, -0.237884],
  [51.572002, -0.238139],
  [51.572037, -0.238179],
  [51.572051, -0.238186],
  [51.572078, -0.238185],
  [51.5721, -0.238175],
  [51.572123, -0.238147],
  [51.572128, -0.238127],
  [51.572127, -0.238094],
  [51.5721, -0.237955],
  [51.572087, -0.237778],
  [51.572095, -0.237754],
  [51.572118, -0.237722],
  [51.572225, -0.23765],
  [51.572272, -0.237645],
  [51.572297, -0.237667],
  [51.57235, -0.237762],
  [51.572365, -0.237777],
  [51.572381, -0.237784],
  [51.572399, -0.237779],
  [51.572423, -0.237762],
  [51.572443, -0.237736],
  [51.572471, -0.237665],
  [51.572482, -0.237595],
  [51.572481, -0.237566],
  [51.572472, -0.237528],
  [51.57242, -0.23739],
  [51.572367, -0.237203],
  [51.572363, -0.23718],
  [51.572369, -0.237054],
  [51.572438, -0.236627],
  [51.572441, -0.236555],
  [51.572436, -0.236486],
  [51.572433, -0.23636],
  [51.572361, -0.236157],
  [51.572311, -0.236014],
  [51.572308, -0.235922],
  [51.57231, -0.235887],
  [51.572318, -0.235868],
  [51.572348, -0.235843],
  [51.572393, -0.235858],
  [51.572434, -0.235916],
  [51.572484, -0.235889],
  [51.57252, -0.235837],
  [51.572535, -0.235812],
  [51.572548, -0.235753],
  [51.572559, -0.235619],
  [51.572561, -0.235579],
  [51.572567, -0.235401],
  [51.572556, -0.235381],
  [51.572536, -0.235363],
  [51.572503, -0.23535],
  [51.572466, -0.235354],
  [51.572437, -0.235373],
  [51.572413, -0.235408],
  [51.57238, -0.235599],
  [51.572354, -0.235688],
  [51.572307, -0.235694],
  [51.572268, -0.235645],
  [51.572251, -0.235526],
  [51.572253, -0.235493],
  [51.572263, -0.235346],
  [51.572261, -0.235238],
  [51.572237, -0.23517],
  [51.572213, -0.235103],
  [51.572158, -0.235069],
  [51.572108, -0.235009],
  [51.572092, -0.234998],
  [51.572074, -0.234971],
  [51.571962, -0.234716],
  [51.571819, -0.234667],
  [51.571771, -0.234586],
  [51.571775, -0.234507],
  [51.571782, -0.234453],
  [51.571789, -0.234407],
  [51.571838, -0.234357],
  [51.571795, -0.234269],
  [51.571779, -0.234196],
  [51.571747, -0.234048],
  [51.571796, -0.233875],
  [51.571861, -0.233756],
  [51.57198, -0.233443],
  [51.570953, -0.232236],
  [51.570628, -0.231882],
  [51.570182, -0.231329],
  [51.569832, -0.23092],
  [51.569551, -0.230547],
  [51.56921, -0.230169],
  [51.568934, -0.229807],
  [51.568532, -0.229383],
  [51.568072, -0.228938],
  [51.567968, -0.228819],
  [51.567839, -0.228638],
  [51.567702, -0.228398],
  [51.567528, -0.228031],
  [51.567374, -0.227738],
  [51.567054, -0.227188],
  [51.566904, -0.226894],
  [51.566793, -0.226721],
  [51.566563, -0.226427],
  [51.566216, -0.225942],
  [51.566037, -0.225705],
  [51.565865, -0.22549],
  [51.565584, -0.225186],
  [51.565489, -0.225072],
  [51.565155, -0.22462],
  [51.564719, -0.224108],
  [51.564123, -0.223431],
  [51.563528, -0.222675],
  [51.563296, -0.22239],
  [51.562941, -0.221955],
  [51.562552, -0.221553],
  [51.562232, -0.221206],
  [51.561673, -0.220663],
  [51.561597, -0.220588],
  [51.561288, -0.220313],
  [51.56012, -0.219324],
  [51.559791, -0.219022],
  [51.559418, -0.21865],
  [51.559125, -0.21832],
  [51.558667, -0.217769],
  [51.558202, -0.217173],
  [51.557996, -0.216943],
  [51.557818, -0.216759],
  [51.557636, -0.216511],
  [51.55739, -0.216176],
  [51.556846, -0.215501],
  [51.556748, -0.215373],
  [51.556343, -0.214855],
  [51.555877, -0.214288],
  [51.555399, -0.213737],
  [51.555186, -0.213501],
  [51.555288, -0.213285],
  [51.55542, -0.213],
  [51.555702, -0.212512],
  [51.555924, -0.212129],
  [51.556155, -0.211698],
  [51.556322, -0.211247],
  [51.556463, -0.210845],
  [51.556754, -0.210031],
  [51.55675, -0.210027],
  [51.556354, -0.209566],
  [51.55633, -0.209539],
  [51.556034, -0.209237],
  [51.555739, -0.208856],
  [51.555731, -0.208845],
  [51.55589, -0.208334],
  [51.555962, -0.208038],
  [51.556087, -0.207523],
  [51.556209, -0.206991],
  [51.556335, -0.206496],
  [51.556372, -0.206336],
  [51.556385, -0.206216],
  [51.556399, -0.20609],
  [51.556416, -0.205992],
  [51.55642, -0.205966],
  [51.556204, -0.205894],
  [51.556136, -0.205898],
  [51.556071, -0.205903],
  [51.555937, -0.205865],
  [51.555555, -0.205878],
  [51.555439, -0.205837],
  [51.555305, -0.205815],
  [51.555307, -0.205779],
  [51.555338, -0.205347],
  [51.555366, -0.205105],
  [51.555411, -0.204976],
  [51.555423, -0.204789],
  [51.555559, -0.204311],
  [51.555615, -0.204082],
  [51.555627, -0.203949],
  [51.555652, -0.203677],
  [51.555692, -0.203348],
  [51.555772, -0.202791],
  [51.555916, -0.20185],
  [51.555938, -0.201649],
  [51.555984, -0.201338],
  [51.556061, -0.200982],
  [51.556147, -0.200551],
  [51.556182, -0.200169],
  [51.556187, -0.199992],
  [51.556193, -0.19941],
  [51.556284, -0.199464],
  [51.556341, -0.199485],
  [51.55646, -0.199502],
  [51.556502, -0.199518],
  [51.556648, -0.199604],
  [51.556825, -0.199669],
  [51.556881, -0.199676],
  [51.556932, -0.199674],
  [51.55698, -0.19966],
  [51.557055, -0.199624],
  [51.557251, -0.199498],
  [51.557717, -0.199126],
  [51.557763, -0.199052],
  [51.557832, -0.198907],
  [51.557906, -0.198791],
  [51.558036, -0.198639],
  [51.558097, -0.19858],
  [51.558157, -0.198533],
  [51.558221, -0.198508],
  [51.558257, -0.198499],
  [51.558448, -0.1985],
  [51.558759, -0.198479],
  [51.558941, -0.198231],
  [51.558941, -0.19823],
  [51.559116, -0.197985],
  [51.558879, -0.197623],
  [51.558913, -0.197564],
  [51.559013, -0.197347],
  [51.559108, -0.197034],
  [51.559183, -0.196818],
  [51.559232, -0.19668],
  [51.559389, -0.196766],
  [51.559593, -0.196817],
  [51.559868, -0.196843],
  [51.559868, -0.196932],
  [51.55988, -0.196945],
  [51.560037, -0.196923],
  [51.560402, -0.196904],
  [51.560608, -0.196919],
  [51.560621, -0.19692],
  [51.560615, -0.196813],
  [51.560695, -0.196751],
  [51.560671, -0.196649],
  [51.560739, -0.196595],
  [51.56067, -0.196244],
  [51.560654, -0.196125],
  [51.560602, -0.195958],
  [51.560522, -0.195595],
  [51.560479, -0.195348],
  [51.560463, -0.195078],
  [51.560481, -0.194852],
  [51.560564, -0.194612],
  [51.560656, -0.194613],
  [51.560705, -0.194569],
  [51.560758, -0.194482],
  [51.560787, -0.194403],
  [51.560824, -0.194302],
  [51.560831, -0.19428],
  [51.560885, -0.19411],
  [51.560914, -0.193982],
  [51.560868, -0.193853],
  [51.560844, -0.193789],
  [51.560951, -0.193616],
  [51.561181, -0.192981],
  [51.561539, -0.19232],
  [51.56158, -0.191747],
  [51.561581, -0.191407],
  [51.561635, -0.19114],
  [51.561706, -0.19096],
  [51.561824, -0.190766],
  [51.561919, -0.190663],
  [51.562055, -0.190619],
  [51.562378, -0.190515],
  [51.562637, -0.190405],
  [51.562766, -0.190371],
  [51.563495, -0.190145],
  [51.563751, -0.19016],
  [51.56397, -0.190143],
  [51.564525, -0.190021],
  [51.564628, -0.190019],
  [51.564701, -0.189997],
  [51.564807, -0.189935],
  [51.564959, -0.1899],
  [51.565057, -0.189847],
  [51.565253, -0.189643],
  [51.565295, -0.189496],
  [51.565354, -0.189423],
  [51.565433, -0.189365],
  [51.565478, -0.189311],
  [51.565514, -0.189252],
  [51.56554, -0.189188],
  [51.565551, -0.18915],
  [51.565579, -0.188701],
  [51.565772, -0.188385],
  [51.565811, -0.188415],
  [51.565915, -0.188093],
  [51.565994, -0.187919],
  [51.566029, -0.187813],
  [51.566053, -0.187729],
  [51.566082, -0.18753],
  [51.566103, -0.187447],
  [51.566124, -0.187391],
  [51.566182, -0.187278],
  [51.56621, -0.187193],
  [51.566465, -0.187017],
  [51.566628, -0.186777],
  [51.566659, -0.186722],
  [51.566702, -0.186644],
  [51.566742, -0.186564],
  [51.566782, -0.186485],
  [51.566788, -0.18647],
  [51.566811, -0.186422],
  [51.566835, -0.186372],
  [51.566858, -0.186322],
  [51.566879, -0.186272],
  [51.5669, -0.18622],
  [51.566921, -0.186168],
  [51.56694, -0.186115],
  [51.567052, -0.185682],
  [51.567169, -0.185241],
  [51.567247, -0.184751],
  [51.567362, -0.184195],
  [51.567414, -0.184008],
  [51.567499, -0.183811],
  [51.567767, -0.183482],
  [51.567973, -0.183719],
  [51.568006, -0.183568],
  [51.568023, -0.183493],
  [51.56867, -0.182211],
  [51.568723, -0.182132],
  [51.568848, -0.182],
  [51.56893, -0.18189],
  [51.568962, -0.181828],
  [51.569007, -0.181711],
  [51.569405, -0.180919],
  [51.569436, -0.180834],
  [51.569669, -0.180975],
  [51.569667, -0.180752],
  [51.569676, -0.180515],
  [51.569699, -0.180181],
  [51.569786, -0.179725],
  [51.56992, -0.179087],
  [51.56992, -0.179061],
  [51.569921, -0.179008],
  [51.569924, -0.178956],
  [51.569927, -0.178902],
  [51.569931, -0.178849],
  [51.569936, -0.178797],
  [51.569942, -0.178744],
  [51.56995, -0.178692],
  [51.569958, -0.17864],
  [51.569967, -0.178589],
  [51.569976, -0.178538],
  [51.569987, -0.178487],
  [51.569999, -0.178438],
  [51.570012, -0.178388],
  [51.570011, -0.178385],
  [51.570015, -0.178371],
  [51.570019, -0.178357],
  [51.570023, -0.178343],
  [51.570026, -0.178328],
  [51.570029, -0.178314],
  [51.570034, -0.178299],
  [51.570037, -0.178285],
  [51.570041, -0.178271],
  [51.570046, -0.178258],
  [51.570052, -0.178245],
  [51.570057, -0.178233],
  [51.570063, -0.178223],
  [51.570069, -0.178211],
  [51.570076, -0.178201],
  [51.570083, -0.17819],
  [51.570091, -0.17818],
  [51.570098, -0.178171],
  [51.570106, -0.178162],
  [51.570114, -0.178153],
  [51.570123, -0.178146],
  [51.570132, -0.178138],
  [51.570141, -0.178132],
  [51.57015, -0.178126],
  [51.570158, -0.17812],
  [51.570166, -0.178115],
  [51.570176, -0.178112],
  [51.570185, -0.178107],
  [51.570195, -0.178105],
  [51.570205, -0.178102],
  [51.570215, -0.1781],
  [51.570224, -0.1781],
  [51.570234, -0.178099],
  [51.570244, -0.1781],
  [51.570253, -0.178101],
  [51.570431, -0.178078],
  [51.570273, -0.177695],
  [51.570266, -0.177678],
  [51.570198, -0.177386],
  [51.57019, -0.176954],
  [51.570066, -0.176514],
  [51.569895, -0.175993],
  [51.569873, -0.175925],
  [51.569794, -0.175934],
  [51.569555, -0.175193],
  [51.56943, -0.175157],
  [51.569422, -0.174888],
  [51.569254, -0.174407],
  [51.569306, -0.174351],
  [51.569392, -0.174261],
  [51.569521, -0.174106],
  [51.569614, -0.173996],
  [51.569717, -0.173852],
  [51.569919, -0.173854],
  [51.569918, -0.173731],
  [51.570242, -0.17374],
  [51.570431, -0.173744],
  [51.570775, -0.173652],
  [51.570987, -0.173548],
  [51.571048, -0.173507],
  [51.571099, -0.173461],
  [51.571121, -0.173443],
  [51.571193, -0.173377],
  [51.571263, -0.173308],
  [51.571276, -0.173296],
  [51.571346, -0.173223],
  [51.571416, -0.17315],
  [51.571483, -0.173074],
  [51.571687, -0.172695],
  [51.571908, -0.172296],
  [51.571919, -0.172091],
  [51.572052, -0.171843],
  [51.572129, -0.171811],
  [51.572238, -0.171697],
  [51.572404, -0.171358],
  [51.57243, -0.171285],
  [51.573022, -0.17124],
  [51.573612, -0.171182],
  [51.573636, -0.170958],
  [51.573691, -0.170587],
  [51.573839, -0.169947],
  [51.573982, -0.169484],
  [51.574003, -0.169482],
  [51.574228, -0.169484],
  [51.574512, -0.16946],
  [51.574712, -0.169472],
  [51.574891, -0.169507],
  [51.575453, -0.169587],
  [51.575795, -0.169635],
  [51.575777, -0.169553],
  [51.576348, -0.169591],
  [51.576399, -0.169753],
  [51.576574, -0.169687],
  [51.576779, -0.169623],
  [51.576921, -0.169567],
  [51.577133, -0.16946],
  [51.57741, -0.169355],
  [51.577426, -0.169346],
  [51.576993, -0.168285],
  [51.576926, -0.168088],
  [51.57735, -0.167757],
  [51.577494, -0.167634],
  [51.577771, -0.167453],
  [51.577868, -0.167377],
  [51.57821, -0.167084],
  [51.578225, -0.167167],
  [51.578259, -0.167361],
  [51.578297, -0.167323],
  [51.578415, -0.167209],
  [51.578537, -0.167052],
  [51.578654, -0.166838],
  [51.57879, -0.166855],
  [51.579663, -0.167016],
  [51.579669, -0.167076],
  [51.580582, -0.167087],
  [51.580584, -0.167136],
  [51.580587, -0.167217],
  [51.580617, -0.167221],
  [51.580705, -0.167234],
  [51.58112, -0.167217],
  [51.581299, -0.16722],
  [51.581537, -0.167147],
  [51.581753, -0.167062],
  [51.581819, -0.167014],
  [51.581897, -0.166958],
  [51.58195, -0.166902],
  [51.581955, -0.166896],
  [51.582042, -0.166216],
  [51.582165, -0.166372],
  [51.582177, -0.166363],
  [51.582463, -0.166134],
  [51.582944, -0.165772],
  [51.583221, -0.165747],
  [51.583436, -0.165204],
  [51.583544, -0.164908],
  [51.583586, -0.165015],
  [51.583596, -0.16505],
  [51.583758, -0.164869],
  [51.583939, -0.164629],
  [51.583957, -0.16449],
  [51.583973, -0.164311],
  [51.584286, -0.16381],
  [51.584327, -0.163746],
  [51.584294, -0.163696],
  [51.584299, -0.163682],
  [51.584313, -0.163634],
  [51.584275, -0.163578],
  [51.584273, -0.163577],
  [51.584263, -0.163563],
  [51.584358, -0.163217],
  [51.584451, -0.162683],
  [51.584515, -0.162506],
  [51.584619, -0.16229],
  [51.584746, -0.162062],
  [51.584864, -0.161919],
  [51.585223, -0.161424],
  [51.585273, -0.161351],
  [51.585356, -0.161223],
  [51.585353, -0.16111],
  [51.58519, -0.160856],
  [51.584978, -0.160542],
  [51.584797, -0.16027],
  [51.584679, -0.160054],
  [51.584585, -0.159885],
  [51.58446, -0.159643],
  [51.584502, -0.159581],
  [51.584779, -0.159204],
  [51.585733, -0.157966],
  [51.586195, -0.157923],
  [51.586216, -0.157922],
  [51.586201, -0.157368],
  [51.586198, -0.157182],
  [51.586203, -0.157186],
  [51.586391, -0.157312],
  [51.586568, -0.15743],
  [51.586583, -0.157672],
  [51.586631, -0.158705],
  [51.587159, -0.158714],
  [51.587412, -0.158704],
  [51.587524, -0.158698],
  [51.587557, -0.158696],
  [51.587555, -0.158655],
  [51.587554, -0.158626],
  [51.587575, -0.158626],
  [51.587579, -0.158623],
  [51.587808, -0.158633],
  [51.587975, -0.158641],
  [51.587977, -0.160273],
  [51.588104, -0.160096],
  [51.588207, -0.160104],
  [51.58821, -0.160104],
  [51.588441, -0.160088],
  [51.588639, -0.16008],
  [51.589004, -0.160076],
  [51.588995, -0.160148],
  [51.589069, -0.160145],
  [51.589206, -0.16014],
  [51.589349, -0.16015],
  [51.589691, -0.160169],
  [51.589719, -0.159768],
  [51.590111, -0.159835],
  [51.590204, -0.159847],
  [51.590388, -0.159802],
  [51.590527, -0.159747],
  [51.590992, -0.159601],
  [51.59158, -0.159481],
  [51.591575, -0.159351],
  [51.591686, -0.159172],
  [51.591732, -0.15907],
  [51.591898, -0.158743],
  [51.591947, -0.158707],
  [51.591979, -0.158694],
  [51.592054, -0.158689],
  [51.592072, -0.158693],
  [51.592269, -0.158813],
  [51.592375, -0.158864],
  [51.592265, -0.159675],
  [51.592509, -0.159775],
  [51.592655, -0.159811],
  [51.592767, -0.159852],
  [51.593394, -0.16017],
  [51.593472, -0.1602],
  [51.59359, -0.16023],
  [51.59373, -0.16023],
  [51.59384, -0.160266],
  [51.59408, -0.160396],
  [51.594215, -0.160485],
  [51.594427, -0.160691],
  [51.59483, -0.160971],
  [51.595111, -0.161026],
  [51.595295, -0.161108],
  [51.596291, -0.161489],
  [51.596834, -0.161716],
  [51.597017, -0.16176],
  [51.59715, -0.16178],
  [51.597393, -0.161774],
  [51.597476, -0.161787],
  [51.597536, -0.161783],
  [51.597596, -0.161769],
  [51.597679, -0.161731],
  [51.600228, -0.15993],
  [51.602044, -0.158694],
  [51.602086, -0.158735],
  [51.604147, -0.157274],
  [51.604921, -0.156774],
  [51.605127, -0.15657],
  [51.605343, -0.156396],
  [51.605357, -0.156368],
  [51.605443, -0.155987],
  [51.605295, -0.156138],
  [51.605203, -0.15616],
  [51.605147, -0.156162],
  [51.605113, -0.156152],
  [51.605097, -0.156141],
  [51.604679, -0.155413],
  [51.604601, -0.155269],
  [51.604549, -0.155187],
  [51.604262, -0.154795],
  [51.604136, -0.154644],
  [51.604073, -0.154576],
  [51.603908, -0.154448],
  [51.603427, -0.154005],
  [51.603, -0.153584],
  [51.602678, -0.153312],
  [51.60209, -0.153385],
  [51.601675, -0.153424],
  [51.601344, -0.153434],
  [51.600987, -0.153468],
  [51.600871, -0.153464],
  [51.600697, -0.153437],
  [51.599833, -0.153217],
  [51.599543, -0.15312],
  [51.599231, -0.153031],
  [51.599056, -0.152924],
  [51.598275, -0.152061],
  [51.597681, -0.151624],
  [51.59759, -0.151549],
  [51.59745, -0.151386],
  [51.597446, -0.151375],
  [51.59839, -0.148795],
  [51.598752, -0.147767],
  [51.598862, -0.147413],
  [51.599019, -0.147503],
  [51.599195, -0.147001],
  [51.599306, -0.146683],
  [51.599907, -0.145095],
  [51.600127, -0.144495],
  [51.600215, -0.144523],
  [51.600418, -0.144524],
  [51.600555, -0.144489],
  [51.60111, -0.144199],
  [51.601233, -0.144027],
  [51.601343, -0.143911],
  [51.601378, -0.143884],
  [51.60149, -0.143823],
  [51.601757, -0.14358],
  [51.601947, -0.143462],
  [51.602212, -0.143258],
  [51.602395, -0.14319],
  [51.60245, -0.143154],
  [51.602492, -0.143112],
  [51.602532, -0.143064],
  [51.602958, -0.142508],
  [51.60318, -0.142241],
  [51.603225, -0.14218],
  [51.603288, -0.142141],
  [51.603468, -0.142115],
  [51.603704, -0.142037],
  [51.603785, -0.142025],
  [51.604277, -0.14204],
  [51.604591, -0.142091],
  [51.60491, -0.142215],
  [51.605047, -0.142323],
  [51.605127, -0.142407],
  [51.605448, -0.142658],
  [51.605737, -0.142825],
  [51.605871, -0.142918],
  [51.605928, -0.142947],
  [51.606346, -0.143104],
  [51.606577, -0.143162],
  [51.607336, -0.143303],
  [51.607736, -0.143406],
  [51.607787, -0.143414],
  [51.607903, -0.143428],
  [51.608232, -0.143453],
  [51.608846, -0.143451],
  [51.609051, -0.142823],
  [51.609533, -0.141138],
  [51.610192, -0.138786],
  [51.610823, -0.139625],
  [51.611358, -0.140272],
  [51.611849, -0.140845],
  [51.612346, -0.141417],
  [51.61303, -0.142097],
  [51.613816, -0.142881],
  [51.613887, -0.14295],
  [51.614784, -0.143837],
  [51.615484, -0.144536],
  [51.615603, -0.144141],
  [51.615648, -0.143944],
  [51.61569, -0.143756],
  [51.615853, -0.143168],
  [51.615964, -0.142796],
  [51.615983, -0.142732],
  [51.615961, -0.142711],
  [51.616158, -0.142057],
  [51.616175, -0.142067],
  [51.616201, -0.142083],
  [51.616228, -0.142026],
  [51.61637, -0.142121],
  [51.616396, -0.142053],
  [51.61643, -0.141964],
  [51.616609, -0.141899],
  [51.61682, -0.141831],
  [51.616958, -0.141742],
  [51.617051, -0.141661],
  [51.617171, -0.141558],
  [51.617253, -0.141446],
  [51.617314, -0.14138],
  [51.617361, -0.141352],
  [51.617397, -0.141318],
  [51.617546, -0.141291],
  [51.617649, -0.141072],
  [51.61768, -0.141013],
  [51.61769, -0.140995],
  [51.617684, -0.140912],
  [51.617674, -0.140776],
  [51.617732, -0.14064],
  [51.61834, -0.139927],
  [51.61849, -0.139752],
  [51.618534, -0.139833],
  [51.61872, -0.139483],
  [51.618817, -0.139369],
  [51.61951, -0.13853],
  [51.619643, -0.138331],
  [51.62022, -0.137574],
  [51.620492, -0.137232],
  [51.620867, -0.136679],
  [51.621224, -0.13617],
  [51.621689, -0.135462],
  [51.621737, -0.135469],
  [51.622393, -0.135572],
  [51.622335, -0.135438],
  [51.622297, -0.13535],
  [51.622336, -0.13507],
  [51.622594, -0.134964],
  [51.622774, -0.134867],
  [51.623061, -0.134744],
  [51.623414, -0.134549],
  [51.623521, -0.134493],
  [51.623847, -0.13428],
  [51.623955, -0.134222],
  [51.623989, -0.134206],
  [51.624102, -0.134232],
  [51.624184, -0.134305],
  [51.624281, -0.134366],
  [51.624394, -0.13435],
  [51.624462, -0.134324],
  [51.624527, -0.134236],
  [51.624539, -0.134181],
  [51.624552, -0.134124],
  [51.624564, -0.13412],
  [51.624795, -0.134065],
  [51.624911, -0.134057],
  [51.625528, -0.13378],
  [51.625978, -0.133584],
  [51.626041, -0.133557],
  [51.626296, -0.133548],
  [51.626304, -0.133549],
  [51.626311, -0.133549],
  [51.62632, -0.133549],
  [51.626327, -0.133548],
  [51.626335, -0.133547],
  [51.626342, -0.133545],
  [51.62635, -0.133542],
  [51.626354, -0.13354],
  [51.626361, -0.133537],
  [51.626368, -0.133532],
  [51.626375, -0.133528],
  [51.626382, -0.133521],
  [51.626388, -0.133515],
  [51.626395, -0.133509],
  [51.626402, -0.133502],
  [51.626415, -0.133488],
  [51.626417, -0.133485],
  [51.626433, -0.13347],
  [51.626446, -0.133454],
  [51.62646, -0.133436],
  [51.626473, -0.133419],
  [51.626485, -0.133405],
  [51.62651, -0.13337],
  [51.626535, -0.133336],
  [51.626558, -0.1333],
  [51.626581, -0.133263],
  [51.626604, -0.133225],
  [51.626626, -0.133185],
  [51.626648, -0.133145],
  [51.626668, -0.133104],
  [51.626684, -0.13307],
  [51.626832, -0.132856],
  [51.626949, -0.132701],
  [51.6271, -0.132572],
  [51.627286, -0.13242],
  [51.627434, -0.132301],
  [51.627594, -0.132207],
  [51.627747, -0.132097],
  [51.62786, -0.131968],
  [51.628052, -0.131757],
  [51.628312, -0.131512],
  [51.628513, -0.131306],
  [51.628544, -0.131395],
  [51.628782, -0.131108],
  [51.628808, -0.131133],
  [51.628886, -0.131169],
  [51.628947, -0.131181],
  [51.629019, -0.13114],
  [51.629325, -0.13085],
  [51.629301, -0.130554],
  [51.629377, -0.130467],
  [51.629462, -0.130657],
  [51.629663, -0.131147],
  [51.630144, -0.130792],
  [51.630411, -0.13071],
  [51.630731, -0.130446],
  [51.631021, -0.130206],
  [51.63096, -0.129804],
  [51.631466, -0.129556],
  [51.63182, -0.129316],
  [51.632266, -0.129147],
  [51.632269, -0.129177],
  [51.632349, -0.129642],
  [51.632417, -0.130348],
  [51.63249, -0.130834],
  [51.632578, -0.131357],
  [51.632804, -0.132044],
  [51.632818, -0.132087],
  [51.632986, -0.132581],
  [51.633131, -0.132986],
  [51.633265, -0.133295],
  [51.63349, -0.133639],
  [51.633651, -0.133872],
  [51.633766, -0.133688],
  [51.633897, -0.133842],
  [51.633968, -0.133922],
  [51.63404, -0.134003],
  [51.634041, -0.134005],
  [51.63387, -0.134279],
  [51.633972, -0.134437],
  [51.634081, -0.134256],
  [51.634248, -0.134532],
  [51.634419, -0.134265],
  [51.63446, -0.134292],
  [51.634527, -0.134334],
  [51.634695, -0.134534],
  [51.634824, -0.134744],
  [51.635092, -0.135284],
  [51.635188, -0.135495],
  [51.63547, -0.136205],
  [51.636134, -0.137685],
  [51.636349, -0.13813],
  [51.636455, -0.138332],
  [51.636515, -0.138438],
  [51.637325, -0.139887],
  [51.637682, -0.140438],
  [51.637978, -0.140826],
  [51.638192, -0.14108],
  [51.638459, -0.141383],
  [51.638794, -0.141765],
  [51.639045, -0.142054],
  [51.639096, -0.14209],
  [51.639313, -0.142319],
  [51.639364, -0.142144],
  [51.639788, -0.142608],
  [51.640198, -0.143052],
  [51.640998, -0.143944],
  [51.642647, -0.145103],
  [51.642081, -0.147921],
  [51.642402, -0.148158],
  [51.642952, -0.148505],
  [51.643109, -0.14858],
  [51.643865, -0.148882],
  [51.644178, -0.149048],
  [51.644632, -0.14918],
  [51.644696, -0.149177],
  [51.644838, -0.149132],
  [51.644912, -0.149124],
  [51.645053, -0.149127],
  [51.645238, -0.149158],
  [51.645261, -0.149174],
  [51.645302, -0.149244],
  [51.645258, -0.150338],
  [51.645254, -0.150815],
  [51.645266, -0.151118],
  [51.645281, -0.15133],
  [51.645362, -0.151752],
  [51.645652, -0.1516],
  [51.645823, -0.152168],
  [51.646825, -0.151309],
  [51.646867, -0.151386],
  [51.646986, -0.151274],
  [51.647205, -0.151068],
  [51.64731, -0.151386],
  [51.64764, -0.152383],
  [51.647984, -0.152274],
  [51.648172, -0.151729],
  [51.648792, -0.14992],
  [51.650076, -0.151019],
  [51.649908, -0.151818],
  [51.649846, -0.152271],
  [51.650054, -0.15233],
  [51.650158, -0.152347],
  [51.650352, -0.152358],
  [51.65074, -0.152402],
  [51.651316, -0.152498],
  [51.651363, -0.152512],
  [51.651467, -0.152565],
  [51.651843, -0.15289],
  [51.652052, -0.15309],
  [51.652452, -0.153356],
  [51.652618, -0.153449],
  [51.652696, -0.153502],
  [51.652643, -0.153796],
  [51.652561, -0.154051],
  [51.652975, -0.154231],
  [51.653226, -0.153986],
  [51.653254, -0.153802],
  [51.653303, -0.15349],
  [51.653428, -0.153544],
  [51.653629, -0.153507],
  [51.654027, -0.15361],
  [51.654459, -0.153698],
  [51.654664, -0.153782],
  [51.654648, -0.153881],
  [51.65485, -0.154197],
  [51.654953, -0.154402],
  [51.655028, -0.154723],
  [51.655188, -0.154713],
  [51.655531, -0.154788],
  [51.655558, -0.154912],
  [51.655704, -0.155557],
  [51.656151, -0.157732],
  [51.656188, -0.157826],
  [51.656204, -0.157851],
  [51.65632, -0.15798],
  [51.656255, -0.1583],
  [51.656751, -0.160515],
  [51.656985, -0.160976],
  [51.657215, -0.161402],
  [51.657963, -0.162779],
  [51.658087, -0.163286],
  [51.658166, -0.163504],
  [51.658224, -0.165042],
  [51.659885, -0.172479],
  [51.660568, -0.175554],
  [51.660764, -0.176508],
  [51.661325, -0.179036],
  [51.661656, -0.180499],
  [51.662023, -0.182294],
  [51.662102, -0.182631],
  [51.662387, -0.183676],
  [51.662423, -0.183914],
  [51.662833, -0.185891],
  [51.663155, -0.185708],
  [51.663861, -0.185231],
  [51.665743, -0.184002],
  [51.666915, -0.1832],
  [51.668601, -0.18211]
];
